// Топовые события
import React, {Component} from "react";
import Sport from "./Sport";
import Loading from "../Loading";
import {connect} from "react-redux";
import {getPopulars} from "../../redux/actions/line";

class TopEvents extends Component {
	constructor(props) {
		super(props);
	}

	componentWillMount() {
		if ( this.props.line.populars.sports.length === 0 ) {
			this.props.onGetPopulars(0);
		}
	}

	render() {
		const {leagues, populars, sports} = this.props.line.populars;

		return (
			<ul className="top-event-list">
				{this.props.line.populars.fetching && <Loading/>}

				{sports !== undefined && sports.map((sport) =>
					<Sport key={sport.id}
					       sport={sport}
					       populars={populars}
					       leagues={leagues.filter((league) => {return league.sport_id === sport.id})}/>
				)}
			</ul>
		);
	}
}

export default connect(
	state => ({
		line : state.line
	}),
	dispatch => ({
		onGetPopulars : (period) => {
			dispatch(getPopulars(period));
		}
	})
)(TopEvents);


// WEBPACK FOOTER //
// ./src/app/components/TopEvents/TopEvents.js